// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/loginBg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg {
  /* background-color: red !important; */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: cover;
}
.cke_editable p {
  margin-bottom: 0;
}
p {
  margin-bottom: 0px;
}
.handlese-kund-item-text-p-margin p {
  margin-top: 14px;
  margin-bottom: 14px;
}
.ld-chat-bot.ld-chat-launcher {
  right: 85px !important;
  transform: rotate(90deg) !important;
  bottom: -61px !important;
  top:unset !important;
}

`, "",{"version":3,"sources":["webpack://./src/styles/root.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,yDAAqD;EACrD,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,wBAAwB;EACxB,oBAAoB;AACtB","sourcesContent":[".bg {\n  /* background-color: red !important; */\n  background-image: url('../assets/images/loginBg.png');\n  background-position: center;\n  background-size: cover;\n}\n.cke_editable p {\n  margin-bottom: 0;\n}\np {\n  margin-bottom: 0px;\n}\n.handlese-kund-item-text-p-margin p {\n  margin-top: 14px;\n  margin-bottom: 14px;\n}\n.ld-chat-bot.ld-chat-launcher {\n  right: 85px !important;\n  transform: rotate(90deg) !important;\n  bottom: -61px !important;\n  top:unset !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
